/* eslint-disable import/no-named-as-default-member */
import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import Metrics from '@spotahome/soyuz-metrics';
import { Mediator } from '@spotahome/soyuz-mediator';
import { trans } from '@spotahome/soyuz/client';
import { Alarm as AlarmIcon, Button } from '@spotahome/ui-library';

import ButtonWithIcon from '@components/ButtonWithIcon';

import { addAlert } from '@components/AlertModal/mutations';
import withModalHandle from '@components/withModalHandle';
import AlertModalWrapper from '@components/AlertModal/index';

import { showSuccessToast } from '@alerts/components/AlertToast';

import { TOKEN_EXPIRED } from '@common/channels';
import SoyuzLocalStorage from '@utils/soyuzLocalStorage';

const LOCAL_STORAGE_KEY = 'openAlertModal';

const parseBudget = (budget = '') => {
  const splitBudget = budget.split('-');

  return {
    minPrice: splitBudget[0],
    maxPrice: splitBudget[1]
  };
};

const getAlertFromFilters = (cityId, filters) => ({
  cityId,
  moveIn: filters['move-in'],
  moveOut: filters['move-out'],
  propertyTypes: filters['type[]'],
  cityAreaIds: filters['areaId[]'],
  ...parseBudget(filters.budget)
});

class AlertButton extends PureComponent {
  componentDidMount() {
    const mustOpenAlertModal = SoyuzLocalStorage.extractItem(LOCAL_STORAGE_KEY);
    if (mustOpenAlertModal && this.props.isUserLogged) {
      this.props.handleModalOpen();
    }
  }

  handleClick = () => {
    const { isUserLogged, handleModalOpen, onClick } = this.props;
    if (isUserLogged) {
      handleModalOpen();
    } else {
      SoyuzLocalStorage.setItem(LOCAL_STORAGE_KEY, true);
      Mediator.publish(TOKEN_EXPIRED);
    }
    onClick();
  };

  handleCreateAlert = async alertData => {
    const { handleModalClose } = this.props;
    Metrics.ga.sendEvent(
      'My alerts modal',
      'create alert button',
      'click button'
    );

    try {
      await addAlert(alertData);
      Metrics.ga.sendEvent(
        'My alerts modal',
        'alert creation success',
        'alert creation success'
      );
      handleModalClose();
      showSuccessToast();
    } catch (error) {
      console.error(error);
    }
  };

  render() {
    const {
      hasButtonVariant,
      cityId,
      filters,
      handleModalClose,
      isModalOpen
    } = this.props;
    return (
      <Fragment>
        {hasButtonVariant ? (
          <Button
            onClick={this.handleClick}
            alt
            className="filter-header__results-button filter-header__results-button--alerts--variant"
          >
            {trans('search.alert.button.save-my-search')}
          </Button>
        ) : (
          <ButtonWithIcon
            className="filter-header__results-button filter-header__results-button--alerts ga-search-form-my-alerts"
            title={trans('search.filter_header.alerts')}
            // eslint-disable-next-line react/jsx-handler-names
            handleOnClick={this.handleClick}
            color="secondary"
          >
            {() => <AlarmIcon size="normal" theme="default" />}
          </ButtonWithIcon>
        )}

        <AlertModalWrapper
          alert={getAlertFromFilters(cityId, filters)}
          cities={this.props.allCities}
          onConfirm={this.handleCreateAlert}
          onClose={handleModalClose}
          isModalOpen={isModalOpen}
        />
      </Fragment>
    );
  }
}

AlertButton.propTypes = {
  cityId: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    'bathrooms[]': PropTypes.arrayOf(PropTypes.string),
    bed: PropTypes.string,
    budget: PropTypes.string,
    'features[]': PropTypes.arrayOf(PropTypes.string),
    'move-in': PropTypes.string,
    'move-out': PropTypes.string,
    poi: PropTypes.string,
    'topology[]': PropTypes.arrayOf(PropTypes.string),
    'type[]': PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  allCities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      currencyIsoCode: PropTypes.string
    })
  ).isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  handleModalOpen: PropTypes.func.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  isUserLogged: PropTypes.bool,
  hasButtonVariant: PropTypes.bool,
  onClick: PropTypes.func
};

AlertButton.defaultProps = {
  isUserLogged: false,
  hasButtonVariant: false,
  onClick: () => {}
};

export default withModalHandle()(AlertButton);
